<template>
  <div>
    <router-link to="/dashboard/cdd-pool"
      ><button class="btn link">
        <i class="las la-angle-left"></i>Go Back
      </button></router-link
    >
    <h3 class="title">Candidate Information</h3>
    <div class="cdd-info">
      <ul class="list">
        <li class="name">
          <div class="heading">Candidate Name</div>
          <div class="info-text">Arakawa Kaoru</div>
        </li>
        <li class="phone">
          <div class="heading">Phone No.</div>
          <div class="info-text">
            <a href="tel:12345667" class="link">081999900</a>
          </div>
        </li>
        <li class="email">
          <div class="heading">Email Address</div>
          <div class="info-text">
            <a href="mailto:arakawa@gmail.com" class="link"
              >arakawa@gmail.com</a
            >
          </div>
        </li>
        <li class="age">
          <div class="heading">Age</div>
          <div class="info-text">28</div>
        </li>
        <li class="gender">
          <div class="heading">Gender</div>
          <div class="info-text">Male</div>
        </li>
        <li class="english-level">
          <div class="heading">English Level</div>
          <div class="info-text">Intermediate</div>
        </li>
        <li class="language">
          <div class="heading">Other Language Skills</div>
          <div class="info-text">Japanese, French, Chinese</div>
        </li>
        <li class="it-skills">
          <div class="heading">PC, IT and Programming Skills</div>
          <div class="info-text">
            - Adobe CC, Microsoft Office, SAP, Fullstack Developer, HTML., CSS,
            Javascript<br />
            - ReactJS, VueJS, SQL, Bootstrap, Docker, Jason<br />
            - Illustration, Photoshop, After Effect, Sketch, Figma, Invision,
            Adobe XD,
          </div>
        </li>
        <li class="job-category">
          <div class="heading">Experienced Job Category</div>
          <div class="info-text">Engineering / Telecommunications</div>
        </li>
        <li class="job-industry">
          <div class="heading">Experienced Job Industry</div>
          <div class="info-text">Engineering / Telecommunications</div>
        </li>
        <li class="salary">
          <div class="heading">Expected Salary (THB)</div>
          <div class="info-text">100,000 - 300,000 THB</div>
        </li>
        <li class="memo">
          <div class="heading">Skills Memo</div>
          <div class="info-text">
            <div class="info-text">
              - Candidate need to focus mainly on new client<br />
              - Need Business to business (B2B) sales background<br />
              - 1st month might need to go office a bit often, but after that
              it’s required 1 day to go office, but candidate able to directly
              go visit their client.<br />
              - If possible candidate with English skill is preferable, but if
              they have very good sales skill, also able to consider.
            </div>
          </div>
        </li>
        <li class="cv-file">
          <div class="heading">CV File</div>
          <div class="file-preview">
            <a><div class="thumbnail"></div></a>
            <div class="file-name">
              <div class="name">
                <a class="file-link">Arakawa Kaoru_CV.pdf</a>
              </div>
              <div class="add-date">Added on 20 Jan 2022</div>
            </div>
          </div>
        </li>
      </ul>
      <div class="recommend-history">
        <sui-accordion exclusive>
          <sui-accordion-title active>
            <div class="label">
              <i class="las la-history"></i>
              <span class="heading">Recommendation History</span>
              <sui-icon name="dropdown" />
            </div>
          </sui-accordion-title>
          <sui-accordion-content active>
            <div class="candidate-table">
              <DashboardCddTable />
            </div>
          </sui-accordion-content>
        </sui-accordion>
      </div>
      <div class="button-group">
        <sui-button @click.native="toggle">
          <button class="btn btn-outline delete-btn" type="submit">
            <i class="las la-trash-alt"></i
            ><span class="text">Delete Candidate</span>
          </button>
        </sui-button>
        <sui-modal v-model="open">
          <div class="modal-custom">
            <sui-button @click.native="toggle" class="close-btn">
              <button type="button">
                <i class="las la-times"></i>
              </button>
            </sui-button>
            <div class="heading">
              Are you sure you want to delete this candidate in your pool?
            </div>
            <div class="description">
              Once deleted, this candidate will be permanently removed from your
              candidate pool.
            </div>
            <div class="button-row">
              <button class="btn delete" type="submit">
                Yes, delete this candidate
              </button>
              <sui-button @click.native="toggle">
                <button class="btn btn-outline no-delete" type="submit">
                  No, I won’t delete
                </button>
              </sui-button>
            </div>
          </div>
        </sui-modal>
        <button class="btn btn-outline" type="submit">Edit</button>
      </div>
    </div>
  </div>
</template>
<script>
import DashboardCddTable from "./DashboardCddTable";
export default {
  name: "DashboardCddPoolDetails",
  components: {
    DashboardCddTable,
  },
  data() {
    return {
      fields: [
        { key: "status", label: "Status" },
        { key: "cddstatus", label: "Candidate Status" },
        { key: "date" },
        { key: "job", label: "Job" },
      ],
      items: [
        {
          status: "employed",
          cddstatus: "closed",
          date: { submit: "04/02/2021", time: "10:00" },
          job: {
            jid: "123456",
            jposition: "Senior Developer",
            jcompany: "Abroaders Co.,Ltd",
          },
        },
        {
          status: "employed",
          cddstatus: "closed",
          date: { submit: "04/02/2021", time: "10:00" },
          job: {
            jid: "123456",
            jposition: "Senior Developer",
            jcompany: "Abroaders Co.,Ltd",
          },
        },
        {
          status: "employed",
          cddstatus: "closed",
          date: { submit: "04/02/2021", time: "10:00" },
          job: {
            jid: "123456",
            jposition: "Senior Developer",
            jcompany: "Abroaders Co.,Ltd",
          },
        },
      ],
    };
  },
  data() {
    return { open: false };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/application";
@import "@/assets/stylesheets/register";
.btn.link {
  background: transparent;
  color: $black;
  font-size: 14px;
  margin-bottom: 1rem;
  padding: 0;
  i {
    margin-right: 8px;
  }
  &:hover,
  &:focus {
    filter: opacity(70%);
  }
}
h3.title {
  color: #1a1a1a;
  font-size: 1.25em;
  font-weight: 700;
  margin: 1.5rem 0;

  &:first-of-type {
    margin-top: 0;
  }
}
.cdd-info {
  .list {
    li {
      margin-bottom: 1.5rem;
      .heading {
        color: $black;
        font-size: 1em;
        font-weight: 700;
        margin-bottom: 0.5rem;
      }
      .info-text {
        color: $black;
        font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
          Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
          "Segoe UI Emoji", "Segoe UI Symbol";
        font-size: 1em;
        line-height: 1.5rem;

        .text-list {
          list-style-type: disc;
          padding-left: 1.2rem;
          li {
            line-height: 1.5rem;
            margin-bottom: 5px;
          }
        }
      }
      .link {
        color: $black;
        text-decoration: underline;
        &:hover,
        &:focus {
          color: $black;
        }
      }
      .file-preview {
        a {
          display: inline-block;
          &:hover .thumbnail::before {
            opacity: 0;
          }
        }
        .thumbnail {
          display: inline-block;
          position: relative;
          width: 200px;
          height: 150px;
          background-image: url("../../images/candidate/cv.jpg");
          margin: 15px 0;
          background-size: cover;
          background-position: top ceil($number: 0);
          border-radius: 15px;
          border: 1px solid rgb(222, 222, 222);
          // box-shadow: 0 1px 2px;
          &::before {
            content: "";
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            right: 0;
            background: linear-gradient(
              180deg,
              rgba(0, 0, 0, 0.5) 0%,
              rgba(0, 0, 0, 0.1) 100%
            );
            border-radius: 15px;
            opacity: 0.4;
            transition: 0.3s all ease-in-out;
          }
        }
        .file-name {
          line-height: 1.5rem;
          .name {
            .file-link {
              color: $blue-primary;
              font-size: 1em;
              &:hover,
              &:focus {
                filter: contrast(150%);
                text-decoration: none;
              }
            }
          }
          .add-date {
            font-size: 12px;
            color: $gray;
          }
        }
      }
    }
  }
  .recommend-history {
    padding-bottom: 1rem;
    .label {
      display: flex;
      align-items: center;
      margin-bottom: 1.5rem;
      .las {
        color: $blue-primary;
        font-size: 24px;
      }
      .heading {
        font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
          Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji",
          "Segoe UI Emoji", "Segoe UI Symbol";
        color: $black;
        font-size: 1.25em;
        font-weight: 700;
        padding: 0 6px;
      }
      .dropdown.icon {
        margin: 0;
        padding: 0;
        vertical-align: text-bottom;
        color: $blue-primary;
      }
    }
  }
  .button {
    display: flex;
    justify-content: center;
    padding: 2rem 0;
    .btn {
      min-width: 120px;
      i {
        font-size: 22px;
        height: auto;
        margin: 0;
        margin-right: 15px;
      }
    }
    .delete-btn {
      border: 2px solid #e84118;
      color: #e84118;
      margin-right: 1rem;
    }
  }
}
.button-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 4rem;
}
//Modal Style
/deep/ .dimmed.dimmable > .ui.animating.dimmer,
.dimmed.dimmable > .ui.visible.dimmer,
.ui.active.dimmer {
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .ui.modal,
.ui.active.modal {
  position: absolute;
  width: 450px;
  height: auto;
  margin: 0 auto !important;
  top: auto !important;
  left: calc(50% - 10vw) !important;
  transform-origin: center !important;
  transition: all ease 0.5s;
}
/deep/ .ui.button {
  background: transparent;
  padding: 0;
}
.modal-custom {
  font-family: "Poppins", sans-serif !important;
  text-align: center;
  padding: 2rem 2rem;
  line-height: 1.5rem;
  color: $black;
  & > * {
    margin-bottom: 1.5rem;
  }
  & > *:last-child {
    margin-bottom: 0;
  }
  .close-btn {
    width: 100%;
    font-size: 22px;
    color: #787a7a;
    justify-content: flex-end;
  }

  .heading {
    font-weight: 700;
    font-size: 1.5em;
    line-height: 2rem;
  }
  .description {
    font-size: 1em;
  }
  .button-row {
    display: inline-flex;
    flex-direction: column;
    & > * {
      margin-bottom: 10px;
    }
    & > *:last-child {
      margin-bottom: 0;
    }
    .delete {
      background: #e84118;
    }
    .no-delete {
      background: transparent;
      border: 2px solid #787a7a;
      color: #787a7a;
    }
  }
}

@media only screen and (max-width: 991px) {
  .cdd-info {
    .list {
      li {
        margin-bottom: 1.5rem;
        .heading {
          font-size: 14px;
        }
        .info-text {
          font-size: 14px;
        }
      }
    }
  }
  .recommend-history {
    padding-bottom: 1rem;
    .label {
      .heading {
        font-size: 14px;
      }
    }
  }
  .button-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    & > * {
      margin-bottom: 10px;
    }
  }
  //Modal Style
  /deep/ .ui.modal,
  .ui.active.modal {
    width: 90%;
    left: auto !important;
  }
  .modal-custom {
    padding: 2rem 1rem;
    line-height: 1.5rem;
    & > * {
      margin-bottom: 1rem;
    }
    .close-btn {
      width: 100%;
      font-size: 22px;
      color: #787a7a;
      justify-content: flex-end;
    }
    .heading {
      font-size: 1.5em;
    }
  }
}
</style>
